import React from 'react'
import Modal from '../../../../../ui_reusable/Modal'
import { Button } from 'rsuite'

const DeleteScenarioModal = ({ open, onClose, onConfirm, scenarioName }) => {
  if (!open) {
    return null
  }

  return (
    <Modal open={open} onClose={onClose} title={`Delete ${scenarioName}`}>
      <Modal.Body>
        <p>
          Are you sure you want to delete the scenario:{' '}
          <strong>{scenarioName}</strong>?
        </p>
        <p>This action cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onConfirm} appearance="primary" color="red">
          Delete
        </Button>
        <Button onClick={onClose} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteScenarioModal
